module.exports = __webpack_public_path__ + "img/farming_16.5fade84d.png";